export const reverseString = (s: string) => {
  return s.split('').reverse().join('');
};
